import React, { useEffect, useState } from 'react';
import { Redirect, useHistory } from 'react-router';
import Actions from '../../components/Actions/Actions';
import Loader from '../../components/Loader/Loader';
import { ROOT_API_URL, PATH_PREFIX } from '../../core/config/config';
import { ReportDateContext } from '../../core/context/report-date-context';
import Content from '../Content/Content';

function PrivateContent(): JSX.Element {
  const token = window.sessionStorage.getItem('token') || '';
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  const [reportDate, setReportDate] = useState(0);
  const [settlementDate, setSettlementDate] = useState(0);

  window.sessionStorage.removeItem('viewAsClient');
  window.sessionStorage.removeItem('key');

  useEffect(() => {
    const ac = new AbortController();
    const validateToken = async (tkn: string) => {
      const apiBase = ROOT_API_URL;
      try {
        const res = await fetch(`${apiBase}/validatetoken`, {
          method: 'POST',
          signal: ac.signal,
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            token: tkn,
          }),
        });
        const resData = await res.json();
        setLoading(false);
        return resData;
      } catch (e) {
        setLoading(false);
      }
      return true;
    };

    validateToken(token).then((response) => {
      if (response.expired) {
        history.push(`${PATH_PREFIX}/login`);
      } else {
        window.sessionStorage.setItem('edition', response.typeDay);
        setReportDate(response.currentDate);
        setSettlementDate(response.settlementDate);
      }
    });
    return () => ac.abort();
  }, [history, token]);

  if (!token) {
    return <Redirect to={`${PATH_PREFIX}/login`} />;
  }

  return loading ? (
    <Loader />
  ) : (
    <div className="PrivateContent">
      <Actions />

      <ReportDateContext.Provider
        value={{ reportDate: new Date(reportDate), settlementDate: new Date(settlementDate) }}
      >
        <Content />
      </ReportDateContext.Provider>
    </div>
  );
}

export default PrivateContent;
